import { useEffect, useState } from 'react'
import { VehicleLocation } from 'server'
import { useFeathersClient } from '@strac/react-client-feathers'

const useVehicleLocationListener = (vehicleId: number): VehicleLocation | undefined => {

  const client = useFeathersClient()

  const [updatedVehicleLocation, setUpdatedVehicleLocation] = useState<VehicleLocation | undefined>()

  useEffect(() => {
    const listener = (data: VehicleLocation) => {
      if (data.vehicle_id === vehicleId) {
        setUpdatedVehicleLocation(data)
      }
    }
    client.service('vehicle-location').on('patched', listener)
    return () => {
      client.service('vehicle-location').removeListener('patched', listener)
    }
  }, [client, vehicleId])

  return updatedVehicleLocation
}

export default useVehicleLocationListener
